var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',[_c('button',{staticClass:"button alpha",attrs:{"id":_vm.id,"type":"submit","disabled":false}},[_c('span',{class:_vm.subLabel ? '' : 'button-text'},[_vm._t("default",function(){return [_c('strong',[_vm._v("Get Your Quote!")])]})],2),_c('div',[_vm._v(_vm._s(_vm.subLabel))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }